import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReadAreasDivisionResponse } from './responses/get-areasdivision-response';
import { ReadConocimientosResponse } from './responses/get-conocimientos-response';
import { ReadDivisionesResponse } from './responses/get-divisiones-response';
import { ReadGenerosResponse } from './responses/get-generos-response';
import { ReadHabilidadesResponse } from './responses/get-habilidades-response';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  habilidadesController = 'Habilidades';
  conocimientosController = 'Conocimientos';
  generosController = 'Generos';
  areasUTPController = 'AreasUTP';
  constructor(private _http: HttpClient) {}

  getGeneros(): Observable<ReadGenerosResponse[]> {
    return this._http.get<ReadGenerosResponse[]>(
      `${environment.url_api}${this.generosController}`      
    );
  }

  getConocimientos(): Observable<ReadConocimientosResponse[]> {
    return this._http.get<ReadConocimientosResponse[]>(
      `${environment.url_api}${this.conocimientosController}/list-conocimientos`      
    );
  }

  getHabilidades(): Observable<ReadHabilidadesResponse[]> {
    return this._http.get<ReadHabilidadesResponse[]>(
      `${environment.url_api}${this.habilidadesController}/list-habilidades`      
    );
  }

  getDivisiones(): Observable<ReadDivisionesResponse[]> {
    return this._http.get<ReadDivisionesResponse[]>(
      `${environment.url_api}${this.areasUTPController}/list-divisiones`      
    );
  }

  getAreasUTPDivision(idDivision : number): Observable<ReadAreasDivisionResponse[]> {
    const paramsObj = { idDivision: idDivision };
    return this._http.get<ReadAreasDivisionResponse[]>(
      `${environment.url_api}${this.areasUTPController}/list-areasdivision`,
      {params:paramsObj}      
    );
  }

}
